/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Sun Outline',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fill="currentColor"
            d="M12 20a.6.6 0 0 1 .6.6v2.8a.6.6 0 0 1-1.2 0v-2.8a.6.6 0 0 1 .6-.6zm-6.505-2.342a.6.6 0 0 1 .848.849l-1.979 1.981a.6.6 0 0 1-.849-.849l1.98-1.98zm12.162 0a.6.6 0 0 1 .849 0l1.979 1.98a.6.6 0 0 1-.849.848l-1.98-1.98a.6.6 0 0 1 0-.849z"
          />
          <path
            fillRule="evenodd"
            d="M12.291 6.348c2.992.152 5.371 2.625 5.371 5.654l-.008.291c-.151 2.992-2.625 5.371-5.654 5.371l-.291-.008c-2.895-.147-5.217-2.468-5.363-5.363l-.008-.291C6.338 8.875 8.873 6.34 12 6.34l.291.008zM12 7.59c-2.437 0-4.412 1.976-4.412 4.412S9.563 16.414 12 16.414s4.412-1.976 4.412-4.412S14.437 7.59 12 7.59z"
          />
          <path d="M3.4 11.398a.6.6 0 1 1 0 1.2H.6a.6.6 0 1 1 0-1.2h2.8zm20 0a.6.6 0 1 1 0 1.2h-2.8a.6.6 0 1 1 0-1.2h2.8zm-3.763-7.884a.6.6 0 1 1 .849.849l-1.979 1.98a.6.6 0 1 1-.849-.849l1.98-1.98zm-16.122 0a.6.6 0 0 1 .849 0l1.979 1.98a.6.6 0 0 1 0 .848.6.6 0 0 1-.848 0l-1.98-1.979a.6.6 0 0 1 0-.849zM12 0a.6.6 0 0 1 .6.6v2.8a.6.6 0 0 1-1.2 0V.6A.6.6 0 0 1 12 0z" />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fill="currentColor"
            d="M22.349 16.001A6.35 6.35 0 0 0 16 9.651a6.35 6.35 0 0 0-6.35 6.35A6.35 6.35 0 0 0 16 22.35v1.2l-.389-.01a7.55 7.55 0 0 1-7.151-7.151l-.01-.388A7.55 7.55 0 0 1 16 8.451l.388.01a7.55 7.55 0 0 1 7.161 7.54l-.01.388A7.55 7.55 0 0 1 16 23.55v-1.2a6.35 6.35 0 0 0 6.349-6.349zM15.4.6a.6.6 0 0 1 1.2 0v4.133a.6.6 0 1 1-1.2 0V.6zm0 26.667a.6.6 0 1 1 1.2 0V31.4a.6.6 0 1 1-1.2 0v-4.133zm16-11.867a.6.6 0 1 1 0 1.2h-4.133a.6.6 0 1 1 0-1.2H31.4zm-26.667 0a.6.6 0 1 1 0 1.2H.6a.6.6 0 1 1 0-1.2h4.133zm22.581 11.065a.6.6 0 0 1-.849.849l-2.923-2.923a.6.6 0 0 1 .849-.848l2.923 2.923zM8.458 7.609a.6.6 0 1 1-.849.849L4.686 5.535a.6.6 0 1 1 .849-.849l2.923 2.923zm18.007-2.923a.6.6 0 0 1 .849.849l-2.923 2.923a.6.6 0 0 1-.849-.849l2.923-2.923zM7.609 23.542a.6.6 0 1 1 .849.849l-2.923 2.923a.6.6 0 0 1-.849-.849l2.923-2.923z"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <g fill="currentColor">
            <path d="M34.074 24.001c0-5.564-4.511-10.074-10.074-10.074s-10.074 4.511-10.074 10.074S18.436 34.075 24 34.075v1.25l-.583-.015A11.33 11.33 0 0 1 12.69 24.583L12.675 24c0-6.254 5.07-11.324 11.324-11.324l.583.015a11.33 11.33 0 0 1 10.741 11.31l-.015.583A11.33 11.33 0 0 1 24 35.325v-1.25c5.564 0 10.074-4.511 10.074-10.074zM23.375.625c0-.345.28-.625.625-.625s.625.28.625.625v6.75c0 .345-.28.625-.625.625s-.625-.28-.625-.625V.625zm0 40c0-.345.28-.625.625-.625s.625.28.625.625v6.75c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-6.75zm24-17.25c.345 0 .625.28.625.625s-.28.625-.625.625h-6.75c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h6.75zm-40 0c.345 0 .625.28.625.625s-.28.625-.625.625H.625C.28 24.625 0 24.345 0 24s.28-.625.625-.625h6.75zm33.596 16.712c.244.244.244.64 0 .884s-.64.244-.884 0l-4.773-4.773c-.244-.244-.244-.64 0-.884s.64-.244.884 0l4.773 4.773zM12.686 11.802c.244.244.244.64 0 .884s-.64.244-.884 0L7.029 7.913c-.244-.244-.244-.64 0-.884s.64-.244.884 0l4.773 4.773z" />
            <use href="#B" />
            <use
              href="#B"
              x="28.285"
              y="-28.285"
            />
          </g>
          <defs>
            <path
              id="B"
              d="M7.913 40.971c-.244.244-.64.244-.884 0s-.244-.64 0-.884l4.773-4.773c.244-.244.64-.244.884 0s.244.64 0 .884l-4.773 4.773z"
            />
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
